import { IMonitoredObject } from '../../state/types';
import { makeFetch } from './_shared/fetchMakers';
import { normalizeSingleMonitoredEntity } from './_shared/normalizers';
import { makeMonitoredObjectUrl } from './_shared/urlMakers';

export const fetchMonitoredObject = makeFetch<IMonitoredObject>(
    makeMonitoredObjectUrl,
    normalizeSingleMonitoredEntity
);
